import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@anchor/react-components/dist/lib/css/global.css';
import { Faro, LogLevel } from "@grafana/faro-core";
import { RumInit } from "@maersk-global/telemetry-web-sdk";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from './authConfig';

const GRAFANA_RUM_API_KEY = "7DVU1csABCuBt3KHsPyMQLksi9LuDRGnR13jnvT9c8HVgLYPyN5mO0AC218Y2A==";
const GRAFANA_RUM_APP_NAME = "edi-subscription-ui-dev";

const faro = RumInit({
  app: {
    name: GRAFANA_RUM_APP_NAME,
    version: "1.0.0",
  },
  apiKey: GRAFANA_RUM_API_KEY,
  debug: true, //false: Prevent showing log,error,etc captured in browser console
  traceLog: true, //Sends Traces to Loki ( For easy querying of traces)
  instrumentations: {
    console: {
      disabledLevels: [LogLevel.TRACE, LogLevel.INFO],
    },
  }
});

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App instance={msalInstance} />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
